var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    attrs: {
      id: "pictureDescription"
    }
  }, [_c("a-form-model", {
    ref: "dataForm",
    attrs: {
      model: _vm.dataForm
    }
  }, [_c("div", {
    staticClass: "descList"
  }, [_c("a-card", {
    attrs: {
      bordered: false
    }
  }, [_c("a-form-model", {
    ref: "dataForm",
    attrs: {
      model: _vm.dataForm
    }
  }, [_c("a-tabs", {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      type: "card",
      id: "dscPan"
    },
    on: {
      change: _vm.tabChange
    },
    model: {
      value: _vm.tabKey,
      callback: function callback($$v) {
        _vm.tabKey = $$v;
      },
      expression: "tabKey"
    }
  }, [_vm._l(_vm.dataForm.descList, function (item, index) {
    return [_c("a-tab-pane", {
      key: item.langId,
      attrs: {
        tab: item.langName
      }
    }, [_vm.specFlag !== 2 ? _c("h3", {
      staticStyle: {
        "padding-top": "24px",
        "padding-left": "24px"
      }
    }, [_vm._v(_vm._s(_vm.$t("public.public")))]) : _vm._e(), _c("a-row", [_c("a-form-model-item", [item.langId == _vm.tabKey ? _c("div", {
      ref: "public",
      refInFor: true,
      staticClass: "desc",
      style: {
        marginTop: _vm.specFlag !== 2 ? 0 : "20px"
      },
      attrs: {
        id: "public"
      }
    }, [_c("tinymce-editor", {
      key: index + "father",
      attrs: {
        id: "tabpublic" + index
      },
      on: {
        handleImgUpload: _vm.imgUpload
      },
      model: {
        value: item.productdesc,
        callback: function callback($$v) {
          _vm.$set(item, "productdesc", $$v);
        },
        expression: "item.productdesc"
      }
    })], 1) : _vm._e()])], 1), _c("a-divider"), _vm._l(item.speclist, function (item2, index2) {
      return [_c("h3", {
        key: index2,
        staticStyle: {
          "padding-left": "24px"
        }
      }, [_vm._v(_vm._s(item2.specvalue))]), _c("a-row", {
        key: "div2" + index2
      }, [_c("a-form-model-item", [item.langId == _vm.tabKey ? _c("div", {
        staticClass: "desc",
        attrs: {
          id: item2.specvalueId + ""
        }
      }, [_c("tinymce-editor", {
        key: "son" + index2,
        attrs: {
          id: "tabKey" + index + index2
        },
        on: {
          handleImgUpload: _vm.imgUpload
        },
        model: {
          value: item2.productdesc,
          callback: function callback($$v) {
            _vm.$set(item2, "productdesc", $$v);
          },
          expression: "item2.productdesc"
        }
      })], 1) : _vm._e()])], 1), index2 != item.speclist.length - 1 ? _c("a-divider", {
        key: "div" + index2
      }) : _vm._e()];
    })], 2)];
  })], 2)], 1)], 1)], 1), _c("footer-tool-bar", [_c("a-button", {
    attrs: {
      loading: _vm.queryLoading,
      type: "primary"
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t("public.save")))])], 1)], 1), _vm.specFlag !== 2 ? _c("a-anchor", {
    staticClass: "anchor",
    attrs: {
      offsetTop: 170
    },
    on: {
      click: _vm.clickAnchor
    }
  }, _vm._l(_vm.specList, function (item) {
    return _c("a-anchor-link", {
      key: item.specvalueId + "anchor2",
      attrs: {
        href: "#" + item.specvalueId,
        title: item.specvalue
      }
    });
  }), 1) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };